var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { map } from 'lodash';
import classNames from 'classnames';
import { Icon as AntIcon, Popover as AntPopover, Tag as AntTag } from 'antd';
import { ArrayMode } from './array';
import { TreeSelect } from '@comall-backend-builder/components-basis';
import { services } from '@comall-backend-builder/core';
var DISPLAY_TYPE = {
  default: Symbol('default'),
  collapsed: Symbol('collapsed'),
  dynamic: Symbol('dynamic')
};
var DEFAULT_MAX_DEFAULT_DISPLAY = 5;

var ArrayTreeNodeTreeMode = function (_super) {
  __extends(ArrayTreeNodeTreeMode, _super);

  function ArrayTreeNodeTreeMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 展示的时候分简单和复杂模式，防止有时候树形结构下数据太多导致页面难以正常显示
   * @return {ReactElement}
   * @param value
   * @param displayInfo
   */


  ArrayTreeNodeTreeMode.prototype.getDisplayComponent = function (value, displayInfo) {
    if (!value) {
      return _super.prototype.getNotAvailableDisplayComponent.call(this, displayInfo);
    }

    var _a = displayInfo.label,
        label = _a === void 0 ? services.language.getText('type.arrayTreeNodeTree.label') : _a,
        overlayStyle = displayInfo.overlayStyle,
        _b = displayInfo.displayType,
        displayType = _b === void 0 ? 'default' : _b,
        overlayClassName = displayInfo.overlayClassName,
        className = displayInfo.className,
        style = displayInfo.style,
        maxLength = displayInfo.maxLength; //动态模式的边界数组长度

    var length = maxLength || DEFAULT_MAX_DEFAULT_DISPLAY;
    var showTags = map(value, function (_a) {
      var id = _a.id,
          name = _a.name;
      return React.createElement(AntTag, {
        key: id
      }, name);
    });

    if (DISPLAY_TYPE[displayType] === DISPLAY_TYPE.collapsed || DISPLAY_TYPE[displayType] === DISPLAY_TYPE.dynamic && value.length > length) {
      return React.createElement(AntPopover, {
        placement: "right",
        overlayStyle: overlayStyle,
        overlayClassName: classNames('mode-array-tree-node-tree', overlayClassName),
        content: React.createElement("div", null, showTags),
        title: label,
        trigger: "hover"
      }, React.createElement("a", {
        style: style,
        className: classNames('mode-array-tree-node-tree-collapsed', className)
      }, services.language.getText('type.arrayTreeNodeTree.sum'), ":", value.length ? value.length : 0, label, React.createElement(AntIcon, {
        type: "profile",
        style: {
          marginLeft: 4
        }
      })));
    }

    return React.createElement("div", {
      className: classNames('type-array mode-array-tree-node-tree', className),
      style: style
    }, showTags);
  };
  /**
   * 树形下拉框编辑模式，提供一个简单的数据转换来从原始值获取初始值
   * 因为是array类型的数据，所以只能是多选的
   * @param controlInfo
   * @return {ReactElement}
   */


  ArrayTreeNodeTreeMode.prototype.getControlComponent = function (controlInfo) {
    var treeData = controlInfo.options;

    var treeSelectProps = __assign(__assign({}, controlInfo), {
      treeData: treeData,
      multiple: true
    });

    return React.createElement(TreeSelect, __assign({}, treeSelectProps));
  };

  return ArrayTreeNodeTreeMode;
}(ArrayMode);

export { ArrayTreeNodeTreeMode };